// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1767":"3b9a5636cec349e3","2929":"d2b1ea9dba84a566","4611":"17e559fbe60603e6"}[chunkId] + ".css";
};